import {serialize} from 'object-to-formdata';

import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

const putBecomeCreatorData = (medicalIdFile, medicalId, becomeCreatorId) => {
  const formData = serialize({
    doctor_profile: {
      ...(medicalIdFile ? {medical_identificator_file: medicalIdFile} : {}),
      medical_identificator: medicalId,
    },
  });

  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.PUT,
    path: `/api/v1/profiles/become_content_creator_requests/${becomeCreatorId}`,
    formData: formData,
  });
};

export default putBecomeCreatorData;
